// extracted by mini-css-extract-plugin
export var bodySections = "_d1-8";
export var gray = "_d1-7";
export var green = "_d1-4";
export var iconContainer = "_d1-9";
export var iconWidgetContainer = "_d1-1";
export var phoneIcon = "_d1-2";
export var red = "_d1-5";
export var statusDot = "_d1-3";
export var widgetContainer = "_d1-0";
export var yellow = "_d1-6";